import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../Button';
import { isPreviousVideoWatched } from './demoVideoUtils';
import { DEMO_VIDEOS_PROGRESS_TYPE } from './demoVideoConstants';

const PlaylistButtons = ({ playPlaylist, activeVideoId, demoVideosProgress, playlist }) => {

    return (
        <div className="demo-video-playlist-buttons">
            {playlist.playlist.map((video, index) => {
                const isNotFirst = index !== 0;
                const className = `demo-video-button ${isNotFirst ? 'answering' : 'reading'}`;
                const isEnabled = !isNotFirst || isPreviousVideoWatched(demoVideosProgress, playlist.playlist[index - 1].demoVideoId);
                return (
                    <Button
                        ariaLabel="Play"
                        role="button"
                        key={video.title}
                        text={video.title}
                        className={classNames(className, { active: activeVideoId === video.demoVideoId })}
                        onClick={() => playPlaylist(video.shufflePosition)}
                        isEnabled={isEnabled}
                    />
                );
            })}
        </div>
    );
};

PlaylistButtons.propTypes = {
    activeVideoId: PropTypes.string,
    playPlaylist: PropTypes.func.isRequired,
    demoVideosProgress: DEMO_VIDEOS_PROGRESS_TYPE.isRequired,
    playlist: PropTypes.object.isRequired,
};

PlaylistButtons.defaultProps = {
    activeVideoId: '',
};

export default PlaylistButtons;
